import React, { FC, HTMLAttributes } from 'react';
import { useTranslation } from '../../utils/translations';
import Logo from '../Logo';
import { LogoVariants } from '../../types';
import { useTheme } from '../../utils/theme';
import styles from './Home.css';

type Props = {
  classNames?: {
    logo?: string;
  };
  label?: string;
  logo: LogoVariants;
  url: string;
  onClick?: HTMLAttributes<HTMLAnchorElement>['onClick'];
};

const Home: FC<Props> = ({
  classNames,
  label,
  logo,
  url,
  onClick
}): JSX.Element => {
  const { isBranded, isTakeover } = useTheme();
  const { translate } = useTranslation();

  const hasInverseLogo = isBranded || isTakeover;

  return (
    <div data-testid="navigation-menu-logo">
      <a
        aria-label={label ? translate(label) : ''}
        className={styles.component}
        href={url}
        tabIndex={0}
        onClick={onClick}
      >
        <Logo
          alt="header_logo_title"
          className={classNames?.logo}
          inverse={hasInverseLogo}
          logo={logo}
        />
      </a>
    </div>
  );
};

export default Home;
